/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import styled from 'styled-components';

const HeaderWrap = styled.header`
  box-sizing: border-box;
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 28px 16px 0;

  @media (min-width: 620px) {
    padding-right: 24px;
    padding-left: 24px;
  }
`;

const Heading = styled.h1`
  max-width: 820px;
  margin: 0;
  color: #243f6f;
  font-size: clamp(1.75rem, 5vw, 32px);
  font-weight: 700;
  line-height: 1.04;
  letter-spacing: -0.035em;

  &::after {
    display: block;
    width: 56px;
    height: 4px;
    margin-top: 18px;
    content: '';
    background: linear-gradient(90deg, #e12827 0 50%, #f06f10 50% 100%);
  }
`;

const Standfirst = styled.p`
  max-width: 720px;
  margin: 18px 0 0;
  color: #4a4a4a;
  font-size: clamp(1rem, 2vw, 1.2rem);
  line-height: 1.5;
`;

export default function Header() {
  return (
    <HeaderWrap>
      <Heading>
        Structural energy measures gain momentum as governments respond to fuel
        market pressures
      </Heading>
      <Standfirst>
        From fuel subsidies and tax relief to conservation campaigns and
        transport measures, governments worldwide are responding to energy
        market disruptions with actions designed to ease pressure on consumers
        and strengthen energy security.
        <br />
        Click on a tick to explore the measures taken by each country.
      </Standfirst>
    </HeaderWrap>
  );
}
